<template>
    <div class="main">
        <header />
        <div class="content">
            <router-view></router-view>

        </div>



    </div>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
export default {
    name: "main-app"
};
</script>
